import { render } from "./ProjectAssignedUserTable.vue?vue&type=template&id=606e1c25&scoped=true&ts=true"
import script from "./ProjectAssignedUserTable.vue?vue&type=script&lang=ts"
export * from "./ProjectAssignedUserTable.vue?vue&type=script&lang=ts"

import "./ProjectAssignedUserTable.vue?vue&type=style&index=0&id=606e1c25&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606e1c25"]])

export default __exports__